// Utility to get Money constructor from sdkLoader
import { types } from './sdkLoader';
export const Money = types.Money;
